// Migrated 1:1 from @nexato/nx-core-module (shared/services/event/eventService.ts) for #684
import { Injectable } from '@angular/core';
import { TimeEntryInput } from '../../entities/timeEntry/timeEntry';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';
import { EventSubscription, EventSubscriptionInput } from '../../entities/events/event';
import { Observable, of, switchMap, take } from 'rxjs';
/**
 * The users service.
 */
@Injectable()
export class EventService {

  constructor(
    private apolloService: ApolloService
  ) {
  }

  /**
   * updates an event subscription
   * @param eventSubscription eventSubscription Input
   * @param callback method
   */
  public resend(eventId: string, callback: (arg: any) => void): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.RESEND_EVENT_MUTATION,
      {
        id: eventId,
      },
      callback
    );
  }
  /**
   * creates an event subscription
   * @param eventSubscriptionInput event subscription input
   * @param callback method
   */
  public close(eventId: string, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.CLOSE_EVENT_MUTATION,
      {
        id: eventId,
      },
      callback
    );
  }


}
